module.exports = __webpack_public_path__ + "static/images/containers/Landing/images/landing-bonus-bg.83af7eba.jpg";


//////////////////
// WEBPACK FOOTER
// ./containers/Landing/images/landing-bonus-bg.jpg
// module id = 3161
// module chunks = 11